import "../../styles/page-header.css";

export const SectionHeader = ({caption}) => {
    return (
        <div className="comp-container">
            <span className="h-line" />
            <span className="h-caption">{caption}</span>
        </div>
    )
}

export const SubHeader = ({caption}) => {
    return (
        <div className="sub-h-container">
            <span className="sub-caption">{caption}</span>
        </div>
    )
}